import { useEffect, RefObject } from "react";

/**
 * @author Pradeep R <pradeep.rajendran@rldatix.com>
 * @createdOn Jan/21/2025
 */
export const useClickOutsideMonitorHook = (
    ref: RefObject<HTMLElement>,
    handler: (event: MouseEvent | TouchEvent) => void
): void => {
    useEffect(() => {
        let startedInside = false;
        let startedWhenMounted = false;

        const listener = (event: MouseEvent | TouchEvent): void => {
            // Do nothing if `mousedown` or `touchstart` started inside ref element
            if (startedInside || !startedWhenMounted) return;
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target as Node)) return;

            handler(event);
        };

        const validateEventStart = (event: MouseEvent | TouchEvent): void => {
            startedWhenMounted = !!ref.current;
            startedInside = !!(ref.current && ref.current.contains(event.target as Node));
        };

        document.addEventListener("mousedown", validateEventStart);
        document.addEventListener("touchstart", validateEventStart);
        document.addEventListener("click", listener);

        return () => {
            document.removeEventListener("mousedown", validateEventStart);
            document.removeEventListener("touchstart", validateEventStart);
            document.removeEventListener("click", listener);
        };
    }, [ref, handler]);
}